var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar5(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 483 709",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.95 180.93H88.91L29.74 298.25a56.12 56.12 0 00-6.85 26.85v262.77c0 56.19 45.55 101.74 101.74 101.74h234.86c56.19 0 101.74-45.55 101.74-101.74V325.41c0-9.58-2.45-19-7.13-27.36l-62.14-117.12h-.01z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.13 13.46H140.38c-52.848 0-95.69 42.842-95.69 95.69v33.9c0 52.848 42.842 95.69 95.69 95.69h195.75c52.848 0 95.69-42.842 95.69-95.69v-33.9c0-52.848-42.842-95.69-95.69-95.69z",
    fill: "#FD934F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350.91 6.42H122.36c-43.79 0-79.29 35.497-79.29 79.285s35.5 79.285 79.29 79.285h228.55c43.791 0 79.29-35.497 79.29-79.285S394.701 6.42 350.91 6.42z",
    fill: "#FED425"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398.99 565.15H85.12c-34.369 0-62.23 27.861-62.23 62.23s27.861 62.23 62.23 62.23h313.87c34.369 0 62.23-27.861 62.23-62.23s-27.861-62.23-62.23-62.23z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.09 73.05h-107c-9.45 0-17.11 7.66-17.11 17.11v1.93c0 9.449 7.66 17.11 17.11 17.11h107c9.45 0 17.11-7.661 17.11-17.11v-1.93c0-9.45-7.66-17.11-17.11-17.11z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M382.1 578.09H107.32c-18.993 0-34.39 15.397-34.39 34.39v5.36c0 18.993 15.397 34.39 34.39 34.39H382.1c18.993 0 34.39-15.397 34.39-34.39v-5.36c0-18.993-15.397-34.39-34.39-34.39z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 15.09,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.64 393.52v211.43c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V394.7l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.84 416.97c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.04 533.38c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M168.04 497.11c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M168.04 461.83c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M168.04 426.14c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M168.04 570.66c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.85 393.52v211.43c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V394.7l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M363.05 416.97c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M401.25 533.38c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M401.25 497.11c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M401.25 461.83c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M401.25 426.14c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M401.25 570.66c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.74 314.66v288.63c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V315.84l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.94 335.1c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M249.14 531.73c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M249.14 495.45c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M249.14 460.18c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M249.14 424.49c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M249.14 387.8c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M249.14 349.95c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M249.14 569c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M248.21 314.66v288.63c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V315.84l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286.41 335.1c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324.61 531.73c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M324.61 495.45c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M324.61 460.18c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M324.61 424.49c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M324.61 387.8c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M324.61 349.95c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M324.61 569c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.74 582.38c21.097 0 38.2-17.103 38.2-38.2s-17.103-38.2-38.2-38.2-38.2 17.103-38.2 38.2 17.103 38.2 38.2 38.2zM256.25 446.35c21.097 0 38.2-17.103 38.2-38.2s-17.103-38.2-38.2-38.2-38.2 17.103-38.2 38.2 17.103 38.2 38.2 38.2z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 15.85,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M387.17 357.92v-32.5c0-9.58-2.45-19-7.13-27.36l-11.99-22.6M387.17 529.62V421.3",
    stroke: "#FBFDFE",
    strokeWidth: 27.97,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar5);
export default ForwardRef;